import React, { useEffect, useState } from "react"
import axios from "axios"
import Select, { MenuPlacement } from "react-select"
import { SelectedRecord } from "../../interfaces/selectedRecord"
import customStyles from "./styles"
import CreatableSelect from "react-select/creatable"
import { betterFetch } from "utils/apis"
import { useQuery } from "react-query"

export const MultiSelect = (props: {
  selected?: number | number[]
  onSelect: Function
  multiple?: boolean
  canCreate?: boolean
  isClearable?: boolean
  loading?: boolean
  flush?: boolean
  endpoint: string
  menuPlacement?: MenuPlacement
  label: Function
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [records, setRecords] = useState<SelectedRecord[]>([])
  const joiner = props.endpoint.includes("?") ? "&" : "?"
  const style = props.flush ? { marginRight: 0 } : {}

  const { data, refetch, isLoading, isRefetching } = useQuery(
    [props.endpoint],
    betterFetch(`${props.endpoint}${joiner}page_size=10000`),
    { refetchOnWindowFocus: false }
  )
  useEffect(() => {
    setRecords(
      (data?.results ?? data ?? []).map((record: any) => ({
        id: record.id,
        value: record.id,
        label: props.label(record),
      }))
    )
  }, [data])

  useEffect(() => {
    if (props.endpoint === "customer-groups") {
      setLoading(true)
      setTimeout(() => setLoading(false), 1)
    }
  }, [props.selected, props.endpoint])

  const defaultValues = records?.filter((r) => {
    // if (props.selected === undefined) return false;
    return props.multiple
      ? ((props.selected as number[]) ?? [])?.some((p) => p === r.id)
      : props.selected === r.id
  })
  const SelectComponent = props.canCreate ? CreatableSelect : Select

  if (isLoading || loading) return <span>Loading...</span>

  return (
    <SelectComponent
      menuPlacement={props.menuPlacement}
      isLoading={props.loading || isLoading || isRefetching}
      isClearable={props.isClearable}
      styles={customStyles(style)}
      isMulti={props.multiple}
      options={records}
      placeholder="Choose..."
      onChange={(value) => props.onSelect(value)}
      value={defaultValues.length ? defaultValues : undefined}
    />
  )
}
